const EventsByTriggerNeed = ['onClick', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onFocus', 'onBlur', 'onContextMenu', 'onKeyDown'];

export { EventsByTriggerNeed };
